import { createModel } from '@rematch/core';
import {
  EditProjectParam,
  JobProjectAddJobParams,
  PROJECT_LIST_TYPE_ENUM,
  PROJECT_STATUS_ENUM,
  ProjectCopyParams,
  ProjectDeleteParams,
  ProjectJobDetail,
  ProjectListParams,
} from 'domains/projectDomain';
import { RootModel } from 'models';
import projectService from 'services/projectService';
import { BaseState, baseReducers } from './baseReducers';

interface ProjectState extends BaseState {
  projectRenderType: PROJECT_LIST_TYPE_ENUM | PROJECT_LIST_TYPE_ENUM.CARD;
  projectRenderDesc: boolean;
  projectSearchType: 'latestDeliveryTime' | 'projectName';
  projectStatus: PROJECT_STATUS_ENUM | PROJECT_STATUS_ENUM.ACTIVE;
  projectActiveNum: number;
  projectCompletedNum: number;
  jobProjectId?: string;
  editProject?: EditProjectParam;
  reloadProjectCard?: () => void;
  reloadProjectJobList?: () => void;
}

export const project = createModel<RootModel>()({
  state: {
    projectRenderType: PROJECT_LIST_TYPE_ENUM.CARD,
    projectStatus: PROJECT_STATUS_ENUM.ACTIVE,
    projectSearchType: 'projectName',
    projectActiveNum: 0,
    projectCompletedNum: 0,
    projectRenderDesc: false,
  } as unknown as ProjectState,
  reducers: {
    ...baseReducers<ProjectState>(),
  },
  effects: (dispatch) => {
    const { project } = dispatch;
    return {
      setJobProjectId(payload: string | undefined): void {
        project.setState({
          jobProjectId: payload,
        });
      },
      setProjectRenderType(payload: PROJECT_LIST_TYPE_ENUM): void {
        project.setState({
          projectRenderType: payload,
        });
      },
      setProjectSearchType(
        payload: 'latestDeliveryTime' | 'projectName'
      ): void {
        project.setState({
          projectSearchType: payload,
        });
      },
      setProjectRenderDesc(payload: boolean): void {
        project.setState({
          projectRenderDesc: payload,
        });
        setTimeout(() => {
          project.reloadProjectCard();
        }, 500);
      },
      setEditProject(payload: EditProjectParam | undefined): void {
        project.setState({
          editProject: payload,
        });
      },
      setProjectStatus(payload: PROJECT_STATUS_ENUM): void {
        project.setState({
          projectStatus: payload,
        });
      },
      async deleteProject(payload: ProjectDeleteParams) {
        const resp = await projectService.deleteProject(payload);
        project.reloadProjectCard();
        return resp;
      },
      async copyProject(payload: ProjectCopyParams) {
        const resp = await projectService.copyProject(payload);
        project.reloadProjectCard();
        return resp;
      },
      reloadProjectCard: (payload, state) => {
        if (typeof state.project.reloadProjectCard === 'function') {
          state.project.reloadProjectCard();
        }
      },
      createProject() {
        return projectService.createProject();
      },
      async getProjectPage(payload: Partial<ProjectListParams>) {
        const projectPage = await projectService.getProjectPage(payload);
        if (payload.active) {
          project.setState({
            projectActiveNum: projectPage.totalElements,
          });
        } else {
          project.setState({
            projectCompletedNum: projectPage.totalElements,
          });
        }
        return projectPage;
      },
      async jobProjectAddJob(
        Payload: JobProjectAddJobParams
      ): Promise<ProjectJobDetail> {
        return await projectService.jobProjectAddJob(Payload);
      },
      reloadProjectJobList: (payload, state) => {
        state.project.reloadProjectJobList?.();
      },
    };
  },
});
